exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-action-popover[data-v-cc3ac2c6]{background:#fff;border:1px solid #ddd;border-radius:4px;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 2px 8px rgba(0,0,0,.15);min-width:200px;z-index:2147483648}.popover-content[data-v-cc3ac2c6]{padding:4px 0}.popover-item[data-v-cc3ac2c6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px 16px;cursor:pointer;-webkit-transition:background-color .2s;transition:background-color .2s}.popover-item[data-v-cc3ac2c6]:hover{background-color:#f5f5f5}.popover-item .icon[data-v-cc3ac2c6]{margin-right:8px}.popover-item span[data-v-cc3ac2c6]{font-size:14px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc3ac2c6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components2/Manage/modal/EmailActionPopover.vue
// module id = U6ei
// module chunks = 3